import type { Theme, SxProps } from "@mui/material/styles";

/**
 * Styles for Split Delays modal component
 */
export const splitDelaysStyles = (
  theme: Theme,
): Record<string, SxProps<Theme>> => ({
  sliderContainer: {
    position: "relative",
    marginBottom: theme.spacing(4),
    paddingTop: theme.spacing(3),
  },
  durationLabel: {
    position: "absolute",
    top: 0,
    transform: "translateX(-50%)",
    textAlign: "center",
    fontSize: "0.75rem",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    padding: "2px 4px",
    borderRadius: "4px",
    fontWeight: "bold",
  },
});
